// En el layout "thumbnail" de escritorio, las imágenes no visibles tienen width:0,
// así que el slider nativo (basado en scroll) no puede avanzar — por eso las flechas
// se agregaron encima de la imagen pero no hacían nada. Esto las conecta al mismo
// mecanismo que ya usan los thumbnails (simula un click sobre el thumbnail siguiente/anterior).
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('media-gallery').forEach(function (gallery) {
    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    var thumbnails = gallery.querySelector('[id^="GalleryThumbnails"]');
    if (!viewer || !thumbnails) return;

    var prevBtn = viewer.querySelector('.slider-button--prev');
    var nextBtn = viewer.querySelector('.slider-button--next');
    if (!prevBtn || !nextBtn) return;

    function step(direction) {
      var thumbButtons = Array.prototype.slice.call(thumbnails.querySelectorAll('.thumbnail-list__item button'));
      if (thumbButtons.length < 2) return;
      var currentIndex = thumbButtons.findIndex(function (btn) {
        return btn.getAttribute('aria-current') === 'true';
      });
      if (currentIndex === -1) currentIndex = 0;
      var nextIndex = (currentIndex + direction + thumbButtons.length) % thumbButtons.length;
      thumbButtons[nextIndex].click();
    }

    prevBtn.addEventListener('click', function (event) {
      event.preventDefault();
      step(-1);
    });
    nextBtn.addEventListener('click', function (event) {
      event.preventDefault();
      step(1);
    });
  });
});
